export default "/assets/images/pet-dander-video-thumbnail.jpg?552c7f63067996b175e0399d1f32a61c";